export const URLEMRPRESA = process.env.REACT_APP_URL_API;

export const CORS = { headers: { "Access-Control-Allow-Origin": "*" } }; // cors

export const defaultSettings = {
  themeMode: "light",
  themeDirection: "ltr",
  themeColorPresets: "red",
  themeLayout: "horizontal",
  themeStretch: false,
};
